/*
    Sponsorship and Chosen monthly rates.

    Resolution order:
      1. The rate supplied by the host on the event payload - the normal path.
      2. The value inlined at build time from SPONSORSHIP_MONTHLY_RATE / _CHOSEN.
      3. The fallback constants below.

    `process.env.*` reads are replaced with string literals by webpack.DefinePlugin, so
    nothing named `process` reaches the browser. Under Vitest they are real Node
    environment variables, which is what makes both branches testable.

    The deployment pipelines require the variables to be set - see ci/required-env-vars.json
    and ci/verify-env-vars.mjs. Local builds fall through to the constants below.

    These constants are stale after a rate change. See .claude/pending-updates.md.
*/
export var SPONSORSHIP_MONTHLY_RATE_FALLBACK = 39;
export var SPONSORSHIP_MONTHLY_RATE_CHOSEN_FALLBACK = 39;
/*
    Config values arrive as strings, so cast before use.

    Do not simplify to `Number(raw) || fallback`. Number("") is 0 and Number(undefined)
    is NaN - both falsy, so `||` appears to work while silently swallowing malformed
    values that should be caught.
*/
export function toRate(raw, fallback) {
    var n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : fallback;
}
// Getters, not constants, so the value is read at call time rather than at module load.
export var getSponsorshipMonthlyRate = function () {
    return toRate(process.env.SPONSORSHIP_MONTHLY_RATE, SPONSORSHIP_MONTHLY_RATE_FALLBACK);
};
export var getChosenMonthlyRate = function () {
    return toRate(process.env.SPONSORSHIP_MONTHLY_RATE_CHOSEN, SPONSORSHIP_MONTHLY_RATE_CHOSEN_FALLBACK);
};
